import { render, staticRenderFns } from "./AddOptions.vue?vue&type=template&id=65c85264&scoped=true"
import script from "./AddOptions.vue?vue&type=script&lang=js"
export * from "./AddOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c85264",
  null
  
)

export default component.exports